module.exports = __webpack_public_path__ + "img/campanha-vendas-2026-cartaz-vertical.6495ac40.jpeg";